module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app-wrapper",
    class: {
      hideSidebar: !_vm.sidebar.opened
    }
  }, [_c('el-tooltip', {
    class: [{
      'width100': _vm.isShrinkage
    }],
    attrs: {
      "effect": "light",
      "disabled": _vm.toggleMer,
      "visible-arrow": false,
      "placement": "right",
      "popper-class": "tooltip_toggle"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    on: {
      "click": _vm.switchSystem
    },
    slot: "content"
  }, [_c('img', {
    staticClass: "switch-img",
    attrs: {
      "src": require("../../assets/imgs/switch.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "menu-logo",
    attrs: {
      "index": "top"
    }
  }, [_c('div', {
    staticClass: "menu-logo-wrapper unipay-div",
    style: (_vm.companyId != 2 ? 'top:0;z-index:2000' : 'top:-78px;z-index:1')
  }, [_c('img', {
    class: ['logo-img', {
      'logo-shrink-img': _vm.isShrinkage
    }],
    attrs: {
      "src": require("../../assets/imgs/qbt.png")
    }
  }), _vm._v(" "), _c('div', {
    class: ['divide-line', {
      'hide-el': _vm.isShrinkage
    }]
  }), _vm._v(" "), _c('div', {
    class: ['logo-system', {
      'hide-el': _vm.isShrinkage
    }]
  }, [_vm._v("Unipay")])]), _vm._v(" "), (_vm.whiteLabel == 'N' || _vm.whiteLabel == 'undefined') ? _c('div', {
    staticClass: "menu-logo-wrapper mipay-div",
    style: (_vm.companyId == 2 ? 'top:0;z-index:2000' : 'top:-78px;z-index:1')
  }, [_c('img', {
    class: ['logo-img', {
      'logo-shrink-img': _vm.isShrinkage
    }],
    attrs: {
      "src": require("../../assets/imgs/miPay.png")
    }
  }), _vm._v(" "), _c('div', {
    class: ['divide-line', {
      'hide-el': _vm.isShrinkage
    }]
  }), _vm._v(" "), _c('div', {
    class: ['logo-system', {
      'hide-el': _vm.isShrinkage
    }]
  }, [_vm._v("MiPay")])]) : _vm._e()])]), _vm._v(" "), _c('sidebar', {
    class: ['sidebar-container', {
      'sidebar-container-shrinkage': _vm.isShrinkage
    }]
  }), _vm._v(" "), _c('div', {
    staticClass: "menu-toggle",
    class: [{
      'width100': _vm.isShrinkage
    }],
    attrs: {
      "index": "bottom"
    }
  }, [_c('svg', {
    staticClass: "svg-icon svg-slide-icon",
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": _vm.toggleSildeBar
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#icon-hamburger"
    }
  })])]), _vm._v(" "), _c('navbar'), _vm._v(" "), _c('div', {
    class: ['main-container', {
      'main-container-shrinkage': _vm.isShrinkage
    }]
  }, [(_vm.isRouterAlive) ? _c('app-main') : _vm._e()], 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-5fce90fd", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5fce90fd"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/layout/Layout.vue
// module id = OBRG
// module chunks = 101